
import { motion } from 'framer-motion';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import { useInView } from '../../../hooks/useInView';
import { Link } from 'react-router-dom';

const LightCranesPage = () => {
  const [ref, isInView] = useInView({ threshold: 0.2 });

  const lightCranes = [
    {
      id: 'sany-stc250',
      name: 'SANY STC250',
      brand: 'SANY',
      capacity: '25 Tons',
      boom: '40m',
      image: 'https://public.readdy.ai/ai/img_res/9bd4cab95606f71eac6b3ed40836ecd4.jpg',
      features: ['Compact Design', 'Urban Access', 'Quick Setup'],
      specs: {
        maxCapacity: '25 tons',
        boomLength: '40m',
        type: 'Truck Crane',
        year: '2023'
      }
    },
    {
      id: 'xcmg-xct25',
      name: 'XCMG XCT25',
      brand: 'XCMG',
      capacity: '25 Tons',
      boom: '39.5m',
      image: 'https://readdy.ai/api/search-image?query=XCMG%20XCT25%20truck%20crane%2025%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20modern%20compact%20mobile%20crane%20with%20telescopic%20boom%20working%20on%20commercial%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20three%20quarter%20angle%20showing%20crane%20versatility%20and%20mobility&width=900&height=700&seq=xcmg-xct25-light-002&orientation=landscape',
      features: ['All Terrain', 'Fast Travel', 'Efficient'],
      specs: {
        maxCapacity: '25 tons',
        boomLength: '39.5m',
        type: 'Truck Crane',
        year: '2023'
      }
    },
    {
      id: 'tadano-gr250n',
      name: 'Tadano GR-250N',
      brand: 'Tadano',
      capacity: '25 Tons',
      boom: '31.7m',
      image: 'https://readdy.ai/api/search-image?query=Tadano%20GR250N%20rough%20terrain%20crane%2025%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20reliable%20compact%20mobile%20crane%20with%20telescopic%20boom%20working%20on%20building%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20side%20angle%20showing%20crane%20stability%20and%20precision&width=900&height=700&seq=tadano-gr250n-light-003&orientation=landscape',
      features: ['Rough Terrain', 'High Mobility', 'Reliable'],
      specs: {
        maxCapacity: '25 tons',
        boomLength: '31.7m',
        type: 'Rough Terrain Crane',
        year: '2022'
      }
    },
    {
      id: 'sany-stc200',
      name: 'SANY STC200',
      brand: 'SANY',
      capacity: '20 Tons',
      boom: '38m',
      image: 'https://readdy.ai/api/search-image?query=SANY%20STC200%20truck%20crane%2020%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20compact%20mobile%20crane%20with%20telescopic%20boom%20working%20on%20residential%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20three%20quarter%20angle%20showing%20crane%20efficiency%20and%20reach&width=900&height=700&seq=sany-stc200-light-004&orientation=landscape',
      features: ['Compact', 'Urban Projects', 'Easy Operation'],
      specs: {
        maxCapacity: '20 tons',
        boomLength: '38m',
        type: 'Truck Crane',
        year: '2023'
      }
    },
    {
      id: 'xcmg-xct20',
      name: 'XCMG XCT20',
      brand: 'XCMG',
      capacity: '20 Tons',
      boom: '37m',
      image: 'https://readdy.ai/api/search-image?query=XCMG%20XCT20%20truck%20crane%2020%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20modern%20compact%20mobile%20crane%20with%20telescopic%20boom%20working%20on%20building%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20side%20angle%20showing%20crane%20versatility%20and%20power&width=900&height=700&seq=xcmg-xct20-light-005&orientation=landscape',
      features: ['All Terrain', 'Fast Setup', 'Versatile'],
      specs: {
        maxCapacity: '20 tons',
        boomLength: '37m',
        type: 'Truck Crane',
        year: '2023'
      }
    },
    {
      id: 'tadano-gr200n',
      name: 'Tadano GR-200N',
      brand: 'Tadano',
      capacity: '20 Tons',
      boom: '29.6m',
      image: 'https://readdy.ai/api/search-image?query=Tadano%20GR200N%20rough%20terrain%20crane%2020%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20reliable%20compact%20mobile%20crane%20with%20telescopic%20boom%20working%20on%20infrastructure%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20three%20quarter%20angle%20showing%20crane%20stability%20and%20efficiency&width=900&height=700&seq=tadano-gr200n-light-006&orientation=landscape',
      features: ['Rough Terrain', 'Compact', 'Reliable'],
      specs: {
        maxCapacity: '20 tons',
        boomLength: '29.6m',
        type: 'Rough Terrain Crane',
        year: '2022'
      }
    },
    {
      id: 'sany-stc160',
      name: 'SANY STC160',
      brand: 'SANY',
      capacity: '16 Tons',
      boom: '35m',
      image: 'https://readdy.ai/api/search-image?query=SANY%20STC160%20truck%20crane%2016%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20compact%20mobile%20crane%20with%20telescopic%20boom%20working%20on%20residential%20building%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20side%20angle%20showing%20crane%20agility%20and%20reach&width=900&height=700&seq=sany-stc160-light-007&orientation=landscape',
      features: ['Compact', 'Urban Access', 'Efficient'],
      specs: {
        maxCapacity: '16 tons',
        boomLength: '35m',
        type: 'Truck Crane',
        year: '2023'
      }
    },
    {
      id: 'xcmg-xct16',
      name: 'XCMG XCT16',
      brand: 'XCMG',
      capacity: '16 Tons',
      boom: '34m',
      image: 'https://readdy.ai/api/search-image?query=XCMG%20XCT16%20truck%20crane%2016%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20modern%20compact%20mobile%20crane%20with%20telescopic%20boom%20working%20on%20commercial%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20three%20quarter%20angle%20showing%20crane%20versatility%20and%20mobility&width=900&height=700&seq=xcmg-xct16-light-008&orientation=landscape',
      features: ['All Terrain', 'Quick Deploy', 'Versatile'],
      specs: {
        maxCapacity: '16 tons',
        boomLength: '34m',
        type: 'Truck Crane',
        year: '2023'
      }
    },
    {
      id: 'tadano-gr160n',
      name: 'Tadano GR-160N',
      brand: 'Tadano',
      capacity: '16 Tons',
      boom: '27.4m',
      image: 'https://readdy.ai/api/search-image?query=Tadano%20GR160N%20rough%20terrain%20crane%2016%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20reliable%20compact%20mobile%20crane%20with%20telescopic%20boom%20working%20on%20building%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20side%20angle%20showing%20crane%20stability%20and%20precision&width=900&height=700&seq=tadano-gr160n-light-009&orientation=landscape',
      features: ['Rough Terrain', 'High Mobility', 'Reliable'],
      specs: {
        maxCapacity: '16 tons',
        boomLength: '27.4m',
        type: 'Rough Terrain Crane',
        year: '2022'
      }
    },
    {
      id: 'sany-stc120',
      name: 'SANY STC120',
      brand: 'SANY',
      capacity: '12 Tons',
      boom: '32m',
      image: 'https://readdy.ai/api/search-image?query=SANY%20STC120%20truck%20crane%2012%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20compact%20mobile%20crane%20with%20telescopic%20boom%20working%20on%20residential%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20three%20quarter%20angle%20showing%20crane%20efficiency%20and%20agility&width=900&height=700&seq=sany-stc120-light-010&orientation=landscape',
      features: ['Compact', 'Urban Projects', 'Easy Setup'],
      specs: {
        maxCapacity: '12 tons',
        boomLength: '32m',
        type: 'Truck Crane',
        year: '2023'
      }
    },
    {
      id: 'xcmg-xct12',
      name: 'XCMG XCT12',
      brand: 'XCMG',
      capacity: '12 Tons',
      boom: '31m',
      image: 'https://readdy.ai/api/search-image?query=XCMG%20XCT12%20truck%20crane%2012%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20modern%20compact%20mobile%20crane%20with%20telescopic%20boom%20working%20on%20building%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20side%20angle%20showing%20crane%20versatility%20and%20reach&width=900&height=700&seq=xcmg-xct12-light-011&orientation=landscape',
      features: ['All Terrain', 'Fast Travel', 'Efficient'],
      specs: {
        maxCapacity: '12 tons',
        boomLength: '31m',
        type: 'Truck Crane',
        year: '2023'
      }
    },
    {
      id: 'tadano-gr120n',
      name: 'Tadano GR-120N',
      brand: 'Tadano',
      capacity: '12 Tons',
      boom: '24.5m',
      image: 'https://readdy.ai/api/search-image?query=Tadano%20GR120N%20rough%20terrain%20crane%2012%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20reliable%20compact%20mobile%20crane%20with%20telescopic%20boom%20working%20on%20infrastructure%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20three%20quarter%20angle%20showing%20crane%20stability%20and%20efficiency&width=900&height=700&seq=tadano-gr120n-light-012&orientation=landscape',
      features: ['Rough Terrain', 'Compact', 'Reliable'],
      specs: {
        maxCapacity: '12 tons',
        boomLength: '24.5m',
        type: 'Rough Terrain Crane',
        year: '2022'
      }
    }
  ];

  return (
    <div className="min-h-screen bg-white font-inter">
      <Navbar />
      
      <main className="pt-32">
        {/* Hero Section */}
        <section className="relative py-32 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://readdy.ai/api/search-image?query=compact%20light%20duty%20crane%20fleet%20on%20construction%20site%20professional%20industrial%20photography%20multiple%20small%20mobile%20cranes%20working%20together%20on%20residential%20and%20commercial%20projects%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20aerial%20view%20showing%20versatility%20and%20efficiency%20of%20light%20equipment&width=1920&height=800&seq=light-cranes-hero-main&orientation=landscape"
              alt="Light Cranes"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-primary/80 via-primary/70 to-primary/80"></div>
          </div>

          <div className="container mx-auto px-4 lg:px-8 relative z-10">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center max-w-4xl mx-auto"
            >
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="flex items-center justify-center gap-4 mb-6"
              >
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Sany_logo.svg/320px-Sany_logo.svg.png" alt="SANY" className="h-12 brightness-0 invert" />
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/XCMG_logo.svg/320px-XCMG_logo.svg.png" alt="XCMG" className="h-12 brightness-0 invert" />
                <img src="https://www.tadano.com/shared/images/common/logo.svg" alt="Tadano" className="h-12 brightness-0 invert" />
              </motion.div>
              <motion.h1 
                className="text-5xl md:text-7xl font-poppins font-black text-white mb-6"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 0.3 }}
              >
                LIGHT DUTY CRANES
              </motion.h1>
              <motion.p 
                className="text-xl md:text-2xl text-white/90 font-inter leading-relaxed mb-8"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
              >
                Versatile fleet of light-duty cranes from 12 to 25 tons capacity
              </motion.p>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.5 }}
                className="flex flex-wrap items-center justify-center gap-8 text-white"
              >
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center">
                    <i className="ri-weight-line text-2xl"></i>
                  </div>
                  <div className="text-left">
                    <div className="font-poppins font-bold text-2xl">12-25</div>
                    <div className="text-white/80 text-sm">Ton Capacity</div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center">
                    <i className="ri-truck-line text-2xl"></i>
                  </div>
                  <div className="text-left">
                    <div className="font-poppins font-bold text-2xl">12+</div>
                    <div className="text-white/80 text-sm">Light Cranes</div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center">
                    <i className="ri-speed-line text-2xl"></i>
                  </div>
                  <div className="text-left">
                    <div className="font-poppins font-bold text-2xl">Fast</div>
                    <div className="text-white/80 text-sm">Deployment</div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* Cranes Grid */}
        <section className="py-24 bg-white" ref={ref}>
          <div className="container mx-auto px-4 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6 }}
              className="text-center mb-16"
            >
              <div className="flex items-center justify-center gap-2 mb-4">
                <div className="w-2 h-2 bg-accent rounded-full"></div>
                <span className="text-accent font-inter font-semibold text-sm uppercase tracking-wider">Our Fleet</span>
              </div>
              <h2 className="text-5xl md:text-6xl font-poppins font-black text-primary mb-6">
                Available Light Cranes
              </h2>
              <p className="text-neutral-500 font-inter text-xl max-w-2xl mx-auto">
                Compact and efficient equipment for urban and residential projects
              </p>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {lightCranes.map((crane, index) => (
                <motion.div
                  key={crane.id}
                  initial={{ opacity: 0, y: 50 }}
                  animate={isInView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  whileHover={{ y: -10 }}
                  className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
                >
                  <Link to={`/cranes/light/${crane.id}`} className="block">
                    <div className="relative h-72 w-full overflow-hidden">
                      <img
                        src={crane.image}
                        alt={crane.name}
                        className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                      <div className="absolute top-4 right-4">
                        <div className="px-4 py-2 bg-accent rounded-full">
                          <span className="text-white font-inter font-bold text-sm">{crane.capacity}</span>
                        </div>
                      </div>
                      <div className="absolute bottom-4 left-4 right-4">
                        <div className="flex items-center gap-2 mb-2">
                          <img 
                            src={crane.brand === 'SANY' ? 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Sany_logo.svg/320px-Sany_logo.svg.png' : crane.brand === 'XCMG' ? 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/XCMG_logo.svg/320px-XCMG_logo.svg.png' : 'https://www.tadano.com/shared/images/common/logo.svg'} 
                            alt={crane.brand} 
                            className="h-6 brightness-0 invert" 
                          />
                        </div>
                        <h3 className="text-2xl font-poppins font-black text-white">
                          {crane.name}
                        </h3>
                      </div>
                    </div>
                    
                    <div className="p-6">
                      <div className="flex items-center gap-4 mb-4">
                        <div className="flex items-center gap-2 text-neutral-600">
                          <i className="ri-ruler-line text-accent"></i>
                          <span className="font-inter text-sm">Boom: {crane.boom}</span>
                        </div>
                        <div className="flex items-center gap-2 text-neutral-600">
                          <i className="ri-calendar-line text-accent"></i>
                          <span className="font-inter text-sm">{crane.specs.year}</span>
                        </div>
                      </div>

                      <div className="flex flex-wrap gap-2 mb-4">
                        {crane.features.map((feature, idx) => (
                          <span
                            key={idx}
                            className="px-3 py-1 bg-neutral-100 text-neutral-700 rounded-full font-inter text-xs"
                          >
                            {feature}
                          </span>
                        ))}
                      </div>

                      <div className="flex items-center justify-between pt-4 border-t border-neutral-100">
                        <span className="text-neutral-500 font-inter text-sm">{crane.specs.type}</span>
                        <div className="flex items-center gap-2 text-accent font-inter font-bold text-sm group-hover:gap-3 transition-all duration-300">
                          View Details
                          <div className="w-5 h-5 flex items-center justify-center">
                            <i className="ri-arrow-right-line"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-24 bg-neutral-50">
          <div className="container mx-auto px-4 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="relative bg-gradient-to-br from-primary to-accent rounded-3xl p-12 md:p-16 overflow-hidden"
            >
              <div className="absolute inset-0 opacity-10">
                <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
                <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
              </div>

              <div className="relative z-10 text-center max-w-3xl mx-auto">
                <h2 className="text-4xl md:text-5xl font-poppins font-black text-white mb-6">
                  Need a Light Crane?
                </h2>
                <p className="text-xl text-white/90 font-inter mb-8">
                  Contact us for availability and pricing
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <motion.a
                    href="/#contact"
                    onClick={(e) => {
                      e.preventDefault();
                      window.REACT_APP_NAVIGATE('/');
                      setTimeout(() => {
                        const element = document.querySelector('#contact');
                        if (element) {
                          element.scrollIntoView({ behavior: 'smooth' });
                        }
                      }, 100);
                    }}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="px-8 py-4 bg-white text-primary rounded-full font-poppins font-bold text-lg hover:shadow-xl transition-all duration-300 cursor-pointer whitespace-nowrap"
                  >
                    Get a Quote
                  </motion.a>
                  <motion.a
                    href="tel:+966123456789"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="px-8 py-4 bg-white/20 text-white rounded-full font-poppins font-bold text-lg hover:bg-white/30 backdrop-blur-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
                  >
                    Call Us Now
                  </motion.a>
                </div>
              </div>
            </motion.div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default LightCranesPage;
